import { Box } from "@mui/material";
import Button from "../../../../input/button";

/**
 * Reusable save changes button for block editing
 *
 * @param {Object} props
 * @param {function} props.onSave - Callback when save button is clicked
 * @param {boolean} [props.disabled=false] - Whether the button is disabled
 * @param {string} [props.text="Save Changes"] - Button text
 * @param {string} [props.color="orange"] - Button color
 */
const SaveBlockButton = ({
  onSave,
  disabled = false,
  text = "Save Changes",
  color = "orange",
}) => {
  return (
    <Box sx={{ mt: 2, width: "100%" }}>
      <Button
        text={text}
        onClick={onSave}
        color={color}
        disabled={disabled}
        fullWidth
      />
    </Box>
  );
};

export default SaveBlockButton;
